/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["logs-list{padding:8px;width:300px;overflow:hidden;border-right:1px solid #000;min-width:300px;max-width:300px}logs-detail{margin-left:16px;overflow:hidden;padding:5px}"];
export { styles as styles };
